import { Card } from './card.model';

export class CardRelation {

constructor(public idTarjeta: number, public tarjeta: Card){}

}
